// test1114
(1114 && 0);
